
<template>
  <Card :title="title">
    <template slot="extra">
      <router-link to="/orderList">返回</router-link>
    </template>
    <Card :style="{ marginBottom: '10px' }">
      <h3 slot="title">入库单基础信息</h3>
      <Form
        ref="formInline"
        :model="formddata"
        :rules="ruleInline"
        :label-width="100"
        inline
      >
        <Row>
          <Col span="12">
            <FormItem label="品牌商单号" prop="spOrderId">
              <Input
                v-model="formddata.spOrderId"
                placeholder="请输入品牌商单号"
              />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="资金商" prop="spCode">
              <Select
                filterable
                v-model="formddata.spCode"
                placeholder="请选择资金商"
                :disabled="orderId !== ''"
                @on-change="spChange"
              >
                <Option
                  v-for="(item, index) in spList"
                  :key="index"
                  :value="item.code"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="仓库" prop="wmsCode">
              <Select
                v-model="formddata.wmsCode"
                placeholder="选择资金商之后，请选择仓库"
                @on-select="setShipToCode"
                :disabled="!formddata.spCode"
                @on-change="wsmChange"
              >
                <Option
                  v-for="(option, index) in wmsCodeList"
                  :value="option.wmsCode"
                  :key="index"
                  >{{ option.wmsName }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem>
              <span slot="label" class="public-require">送达方编码</span>
              <Input
                v-model="formddata.shipToCode"
                placeholder="请输入送达方编码"
                disabled
              />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="备注">
              <Input
                v-model="formddata.remark"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                placeholder="请输入备注"
              ></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Card>
    <Card :style="{ marginBottom: '10px' }">
      <h3 slot="title">入库单商品信息</h3>
      <template slot="extra">
        <Button type="primary" icon="md-add" @click="openModal"
          >添加入库商品</Button
        >
      </template>
      <Table :columns="columns" :data="tbList">
        <template slot-scope="{ row }" slot="produceDate">
          <DatePicker
            :value="row.produceDate"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择发送时间"
            @on-change="(e) => tbChange(e, row, 'produceDate')"
            transfer
          ></DatePicker>
        </template>
        <template slot-scope="{ row }" slot="count">
          <Input
            :value="row.count"
            @on-change="(e) => tbChange(e.target.value, row, 'count')"
            placeholder="请输入数量"
          />
        </template>
        <template slot-scope="{ row, i }" slot="action">
          <a href="javascript:;" @click="deleteFn(row, i)">删除</a>
        </template>
      </Table>
    </Card>
    <div style="text-align: center">
      <Button type="primary" @click="handleSubmit('formInline')"
        >生产入库单</Button
      >
    </div>
    <Modal
      v-model="formModel"
      title="入库商品"
      :loading="formModalLoading"
      :mask-closable="false"
      @on-ok="addAction"
      @on-cancel="cancelAction"
    >
      <Form
        ref="formValidate"
        :model="formData"
        :rules="ruleValidate"
        :label-width="80"
      >
        <FormItem label="商品" prop="code">
          <Select v-model="formData.code" placeholder="请选择商品">
            <Option
              v-for="(option, index) in skuList"
              :value="option.skuCode"
              :key="index"
              >{{ option.skuName }}</Option
            >
          </Select>
        </FormItem>
      </Form>
    </Modal>
  </Card>
</template>
<script>
const columns = [
  {
    title: "商品名称",
    align: "center",
    key: "name",
  },
  {
    title: "生产日期",
    align: "center",
    slot: "produceDate",
  },
  {
    title: "商品数量",
    align: "center",
    slot: "count",
  },
  {
    title: "操作",
    align: "center",
    slot: "action",
  },
];
export default {
  data() {
    return {
      title: "新增",
      columns,
      tbList: [],
      spList: [],
      wmsCodeList: [],
      skuList: [],
      orderId: "",
      formddata: {
        spOrderId: "",
        shipToCode: "",
        spCode: "",
        wmsCode: "",
        remark: "",
      },
      ruleInline: {
        spOrderId: [
          { required: true, message: "请输入品牌商单号", trigger: "blur" },
        ],
        spCode: [
          { required: true, message: "请选择资金商", trigger: "change" },
        ],
        wmsCode: [{ required: true, message: "请选择仓库", trigger: "change" }],
      },
      formModel: false,
      formModalLoading: true,
      formData: {
        code: "",
      },
      ruleValidate: {
        code: [{ required: true, message: "请选择商品", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getOption();
    this.getDetail();
  },
  methods: {
    openModal() {
      if (
        this.formddata.wmsCode == "" ||
        this.formddata.wmsCode == undefined ||
        this.formddata.wmsCode == null
      ) {
        this.$Message.error("请先选择仓库");
        return false;
      }
      this.formModel = true;
    },
    spChange(va) {
      let data = {
        spCode: va,
        pageSize: 9999,
      };
      this.$api.wareSearch(data).then((res) => {
        if (res.code == "200") {
          this.wmsCodeList = res.data;
        }
      });
    },
    wsmChange(va) {
      let data = {
        shipToCode: this.formddata.shipToCode,
        wmsCode: va,
      };
      this.$api.purchSkuList(data).then((res) => {
        if (res.code == "200") {
          this.skuList = res.data;
        }
      });
    },
    getOption() {
      this.$api["spSearchAll"]({}).then((res) => {
        if (res.code == "200") {
          this.spList = res.data;
        }
      });
    },
    getDetail() {
      let q = this.$route.query;
      if (q.orderId) {
        this.orderId = q.orderId;
        this.title = "编辑";
        this.$api["purchDetail"](q).then((res) => {
          if (res.code == "200") {
            let d = res.data;
            Object.keys(this.formddata).forEach((key) => {
              this.formddata[key] = d[key];
            });
            this.tbList = d.skuList;
            this.spChange(d.spCode);
            this.wsmChange(d.wmsCode);
          }
        });
      }
    },
    setShipToCode(code) {
      this.tbList = [];
      this.wmsCodeList.forEach((item) => {
        if (item.wmsCode == code) {
          this.formddata.shipToCode = item.shipToCode;
        }
      });
    },
    handleSubmit(name) {
      let data = this.formddata;
      let list = [...this.tbList].map((item) => {
        delete item.name;
        return item;
      });
      data.skuList = list;
      let http = "purchCreate";
      if (this.orderId) {
        data.orderId = this.orderId;
        http = "purchUpdate";
      }
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$api[http](data).then((res) => {
            if (res.code == "200") {
              this.$Message.success("操作成功");
              this.$router.replace({ path: "/orderList" });
            }
          });
        }
      });
    },
    deleteFn(d, i) {
      this.tbList = [...this.tbList].filter((item) => {
        return item.skuCode != d.skuCode;
      });
    },
    tbChange(v, i, t) {
      this.tbList = this.tbList.map((item, index) => {
        item[t] = i.skuCode == item.skuCode ? v : item[t];
        return item;
      });
    },
    addAction() {
      this.formModalLoading = false;
      this.$nextTick(() => {
        this.formModalLoading = true;
      });
      let list = [...this.tbList].map((item) => {
        return item.skuCode;
      });
      if (list.indexOf(this.formData.code) != -1) {
        this.$Message.warning("商品已存在");
        return;
      }
      let obj = {
        skuCode: this.formData.code,
        produceDate: "",
        count: "",
      };
      this.$refs["formValidate"].validate((valid) => {
        if (valid) {
          this.skuList.forEach((e) => {
            if (this.formData.code == e.skuCode) {
              obj.name = e.skuName;
            }
          });
          this.tbList = [...this.tbList, obj];
          this.cancelAction();
        }
      });
    },
    cancelAction() {
      Object.keys(this.formData).forEach((key) => {
        this.formData[key] = "";
      });
      this.$refs["formValidate"].resetFields();
      this.formModel = false;
    },
  },
};
</script>
<style scoped>
.ivu-form-inline .ivu-form-item {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/warehouse/orderAdd.vue